<template>
  <div class="all">
    <div class="switch">
      <span style="color: #666666; font-size: 14px; margin-right: 5px">显示更多信息</span>
      <el-switch
          v-model="showMore"
          active-color="#1ab394"
          inactive-color="#999999"
      style="margin-right: 10px">
      </el-switch>
      <el-button @click="switchChange(2)" size="small" :type="switchValue === 2 ? 'primary' : ''">志愿方案</el-button>
      <el-button type="primary" size="small" @click="addCollegeClick">院校添加</el-button>
      <el-button type="primary" size="small" v-if="volunteerMode === 3" @click="addSpecialtyOptionsClick(0)">
        专业组添加
      </el-button>
      <el-button type="primary" size="small" @click="addSpecialtyClick()">专业添加</el-button>
      <el-button :label="1" @click="switchChange(1)" size="small" :type="switchValue === 1 ? 'primary' : ''">院校志愿
      </el-button>
      <el-button :label="2" @click="switchChange(3)" size="small" v-if="volunteerMode === 3"
                 :type="switchValue === 3 ? 'primary' : ''">专业组志愿
      </el-button>
      <el-button type="success" size="small" @click="exportTemplate(switchValue, 0)" v-if="draftId && switchValue !== 2">打印</el-button>
      <el-dropdown style="margin-left: 10px; margin-right: 10px" trigger="click" @click.native.stop v-if="draftId  && switchValue === 2">
        <el-button type="success" size="small">打印</el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="exportTemplate(switchValue, 0)">普通打印</el-dropdown-item>
          <el-dropdown-item @click.native="exportTemplate(switchValue, 1)">更多信息打印</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="danger" size="small" @click="batchDelete">批量删除</el-button>
    </div>
    <!-- 院校志愿 -->
    <div class="table" v-if="switchValue === 1">
      <el-table size="mini" style="width: 100%" ref="schoolTable" :data="collegePlanList" :max-height="tableHeigth"
                :row-class-name="tableRowClassName" border row-key="specialtyUuid"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px', 'padding': '0px' }"
                @selection-change="handleCollegeSelectionChanged" @row-click="handleCollegeRowSelectionChanged">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="aspirationName" label="志愿" width="60">
          <template slot-scope="scope">
            {{ scope.row.sort }}
          </template>
        </el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" width="80"></el-table-column>
        <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true" min-width="150">
        </el-table-column>
        <el-table-column  prop="collegeTag" label="院校标签" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeTag ? scope.row.collegeTag : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column  prop="collegeCharacter" label="院校性质" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeCharacter ? scope.row.collegeCharacter : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="专业数量" width="90" v-if="volunteerMode !== 3" key="specialtyList">
          <template slot-scope="scope">
            <div
                :class="scope.row.specialtyList ? scope.row.specialtyList.length >= 1 ? scope.row.specialtyList[0].specialtyName ? '' : 'colorRed' : 'colorRed' : 'colorRed'">
              {{
                scope.row.specialtyList ? scope.row.specialtyList.length === 1 ?
                    scope.row.specialtyList[0].specialtyName
                        ? '1' : '0' : scope.row.specialtyList.length : '0'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="专业组数量" width="100" v-if="volunteerMode === 3" key="optionsList">
          <template slot-scope="scope">
            <div :class="scope.row.optionsList ? (scope.row.optionsList.length > 0 ? '' : 'colorRed') : 'colorRed'">
              {{ scope.row.optionsList ? scope.row.optionsList.length : '0' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_year_this')">
              {{ admissionYear }}最低分
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.scoreYearThis === null">0</div>
            <div v-else>{{ scope.row.scoreYearThis }}</div>
          </template>
        </el-table-column>
        <el-table-column width="72">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_this')">
              {{ admissionYear }}最低位次
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.accumulateYearThis === null">0</div>
            <div v-else>{{ scope.row.accumulateYearThis }}</div>
          </template>
        </el-table-column>
        <el-table-column width="72">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_last')">
              {{ admissionYear - 1 }}最低位次
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.accumulateYearLast === null">0</div>
            <div v-else>{{ scope.row.accumulateYearLast }}</div>
          </template>
        </el-table-column>
        <el-table-column width="72">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_other')">
              {{ admissionYear - 2 }}最低位次
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.accumulateYearOther === null">0</div>
            <div v-else>{{ scope.row.accumulateYearOther }}</div>
          </template>
        </el-table-column>
        <el-table-column width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_last')">
              {{ planYear - 1 }}计划数
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.planYearLast === null">0</div>
            <div v-else>{{ scope.row.planYearLast }}</div>
          </template>
        </el-table-column>
        <el-table-column width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_this')">
              {{ planYear }}计划数
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.planYearThis === null">0</div>
            <div v-else>{{ scope.row.planYearThis }}</div>
          </template>
        </el-table-column>
        <el-table-column label="计划增减" width="80">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_diff')">
              计划增减
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.planDiff">{{ scope.row.planDiff }}</div>
            <div v-else>0</div>
          </template>
        </el-table-column>
        <el-table-column label="院校城市" width="120" v-if="showMore">
          <template slot-scope="scope">
            <span v-if="scope.row.collegeProvince">{{scope.row.collegeProvince}}</span>
            <span v-if="scope.row.collegeCity">{{scope.row.collegeCity}}</span>
          </template>
        </el-table-column>
        <el-table-column label="保研率" prop="postgraduateAdmissionRate" width="80" v-if="showMore">
        </el-table-column>
        <el-table-column label="硕士专业数" prop="masterSpecialtyNum" width="70" v-if="showMore">
        </el-table-column>
        <el-table-column label="博士专业数" prop="doctorSpecialtyNum" width="70" v-if="showMore">
        </el-table-column>
        <el-table-column label="排序" width="80">
          <template slot-scope="scope">
            <input size="small" @click.stop="kong($event)" v-model="scope.row.sort"
                   @blur="collegeSortChanged(scope.row, scope.$index)"
                   style="width: 26px;text-align:center;padding-left:10px;padding-right:10px"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button style="font-size:14px;" type="text" @click.stop="collegeAddSpecialty(scope.row)"
                       v-if="volunteerMode !== 3">
              添加专业
            </el-button>
            <el-button style="font-size:14px;" type="text" v-if="volunteerMode === 3"
                       @click.stop="addSpecialtyOptionsClick(1, scope.row)">添加专业组
            </el-button>
            <el-button style="font-size:14px;" type="text" @click.stop="eidit(scope.row)">编辑</el-button>
            <el-button type="text" style="color: #f56c6c;font-size:14px;" @click.stop="deleteCollegePlan(scope.$index)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 专业组志愿 -->
    <div class="table" v-if="volunteerMode === 3 && switchValue === 3">
      <el-table size="mini" ref="optionsTable" row-key="specialtyUuid" :max-height="tableHeigth" style="width: 100%"
                :row-class-name="tableRowClassName" :data="optionsPlanList" border
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px', 'padding': '0px' }"
                @selection-change="handleSelectionOptionsChange" @row-click="handleRowSelectionChangeOptions">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="aspirationName" label="志愿" width="60">
          <template slot-scope="scope">
            {{ scope.row.sort }}
          </template>
        </el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" width="80"></el-table-column>
        <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true"
                         min-width="120"></el-table-column>
        <el-table-column prop="specialtyNames" label="专业组代码" width="100"></el-table-column>
        <el-table-column prop="specialtyOptions" label="专业组名称" :show-overflow-tooltip="true" min-width="150">
        </el-table-column>
        <el-table-column  prop="collegeTag" label="院校标签" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeTag ? scope.row.collegeTag : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column  prop="collegeCharacter" label="院校性质" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeCharacter ? scope.row.collegeCharacter : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="包含专业" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.specialtyName ? scope.row.specialtyName : "/" }}
          </template>
        </el-table-column>
        <el-table-column label="选考科目要求" min-width="150" show-overflow-tooltip>0
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column label="专业数量" width="90">
          <template slot-scope="scope">
            <div
                :class="scope.row.specialtyList ? scope.row.specialtyList.length >= 1 ? scope.row.specialtyList[0].specialtyName ? '' : 'colorRed' : 'colorRed' : 'colorRed'">
              {{
                scope.row.specialtyList ? scope.row.specialtyList.length === 1 ?
                    scope.row.specialtyList[0].specialtyName
                        ? '1' : '0' : scope.row.specialtyList.length : '0'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_year_this')">
              {{ admissionYear }}最低分
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.scoreYearThis ? scope.row.scoreYearThis : '0' }}
          </template>
        </el-table-column>
        <el-table-column width="72">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_this')">
              {{ admissionYear }}最低位次
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.accumulateYearThis ? scope.row.accumulateYearThis : '0' }}
          </template>
        </el-table-column>
        <el-table-column :label="planYear - 1 + '计划数'" width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_last')">
              {{ planYear - 1 }}计划数
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.planYearLast ? scope.row.planYearLast : '0' }}
          </template>
        </el-table-column>
        <el-table-column width="65">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_this')">
              {{ planYear }}计划数
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.planYearThis ? scope.row.planYearThis : '0' }}
          </template>
        </el-table-column>
        <el-table-column label="计划增减" width="80">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_diff')">
              计划增减
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.planDiff ? scope.row.planDiff : '0' }}
          </template>
        </el-table-column>
        <el-table-column label="院校城市" width="120" v-if="showMore">
          <template slot-scope="scope">
            <span v-if="scope.row.collegeProvince">{{scope.row.collegeProvince}}</span>
            <span v-if="scope.row.collegeCity">{{scope.row.collegeCity}}</span>
          </template>
        </el-table-column>
        <el-table-column label="保研率" prop="postgraduateAdmissionRate" width="80" v-if="showMore">
        </el-table-column>
        <el-table-column label="硕士专业数" prop="masterSpecialtyNum" width="70" v-if="showMore">
        </el-table-column>
        <el-table-column label="博士专业数" prop="doctorSpecialtyNum" width="70" v-if="showMore">
        </el-table-column>
<!--        <el-table-column label="软科排名" prop="softScienceRanking" width="80" v-if="showMore">-->
<!--        </el-table-column>-->
<!--        <el-table-column label="学科评估" prop="academicAssessment" width="100" show-overflow-tooltip v-if="showMore">-->
<!--        </el-table-column>-->
<!--        <el-table-column label="专业硕士点" prop="masterSpecialty" width="100" show-overflow-tooltip v-if="showMore">-->
<!--        </el-table-column>-->
<!--        <el-table-column label="专业博士点" prop="doctorSpecialty" width="100" show-overflow-tooltip v-if="showMore">-->
<!--        </el-table-column>-->
        <el-table-column label="排序" width="80">
          <template slot-scope="scope">
            <input size="small" @click.stop="kong($event)" v-model="scope.row.sort"
                   style="width: 26px;text-align:center;padding-left:10px;padding-right:10px"
                   @blur="specialtyOptionsSortChanged(scope.row, scope.$index)"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="170">
          <template slot-scope="scope">
            <el-button style="font-size:14px;" type="text" @click.stop="addSpecialtyByOptionsClick(scope.row)">添加专业
            </el-button>
            <el-button style="font-size:14px;" type="text" @click.stop="editSpecialtyByOptionsClick(scope.row)">编辑
            </el-button>
            <el-button type="text" style="color: #f56c6c;font-size:14px;"
                       @click.stop="deleteSpecialtyOptions(scope.$index)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 院校/专业组 专业志愿 -->
    <div class="table" v-if="(volunteerMode === 3 || volunteerMode === 1) && switchValue === 2">
      <el-table size="mini" ref="majorTable" row-key="specialtyUuid" style="width: 100%" :max-height="tableHeigth"
                :row-class-name="tabRowClassName" :data="specialtyPlanList" border :span-method="objectOneMethod"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px', 'padding': '0px' }"
                @selection-change="handleSelectionMajorChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="志愿" width="60">
          <template slot-scope="scope">
            {{ scope.row.sort }}
          </template>
        </el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" width="80" key="collegeCode">
        </el-table-column>
        <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true" min-width="120"
                         key="collegeName"></el-table-column>
        <el-table-column prop="specialtyNames" label="专业组代码" v-if="volunteerMode === 3" width="100"
                         key="specialtyNames">
        </el-table-column>
        <el-table-column prop="specialtyOptions" label="专业组名称" :show-overflow-tooltip="true"
                         v-if="volunteerMode === 3"
                         key="specialtyOptions" min-width="150"></el-table-column>
        <el-table-column  prop="collegeTag" label="院校标签" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeTag ? scope.row.collegeTag : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column  prop="collegeCharacter" label="院校性质" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeCharacter ? scope.row.collegeCharacter : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="包含专业" min-width="120" show-overflow-tooltip v-if="volunteerMode === 3"
                         key="specialtyName1">
          <template slot-scope="scope">
            {{ scope.row.specialtyName1 ? scope.row.specialtyName1 : "/" }}
          </template>
        </el-table-column>
        <el-table-column label="选考科目要求" min-width="150" show-overflow-tooltip v-if="volunteerMode === 3"
                         key="requiredType">
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="scoreYearThis1" width="65" key="scoreYearThis2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_year_this1')">
              {{ admissionYear }}最低分
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearThis2" width="72" key="accumulateYearThis2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_this2')">
              {{ admissionYear }}最低位次
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearLast2" width="72" key="accumulateYearLast2szy" v-if="volunteerMode === 1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_last2')">
              {{ admissionYear - 1 }}最低位次
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearOther2" width="70" key="accumulateYearOther2szy"
                         v-if="volunteerMode === 1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_other2')">
              {{ admissionYear - 2 }}最低位次
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYearLast1" width="65" key="planYearLast2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_last1')">
              {{ planYear - 1 }}计划数
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYearThis1" width="65" key="planYearThis2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_this1')">
              {{ planYear }}计划数
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planDiff1" width="80" key="planDiff2szy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_diff1')">
              计划增减
            </div>
          </template>
        </el-table-column>
        <el-table-column label="院校城市" width="120" v-if="showMore">
          <template slot-scope="scope">
            <span v-if="scope.row.collegeProvince">{{scope.row.collegeProvince}}</span>
            <span v-if="scope.row.collegeCity">{{scope.row.collegeCity}}</span>
          </template>
        </el-table-column>
        <el-table-column label="保研率" prop="postgraduateAdmissionRate" width="80" v-if="showMore">
        </el-table-column>
        <el-table-column label="硕士专业数" prop="masterSpecialtyNum" width="70" v-if="showMore">
        </el-table-column>
        <el-table-column label="博士专业数" prop="doctorSpecialtyNum" width="70" v-if="showMore">
        </el-table-column>
        <el-table-column prop="specialtyCode" label="专业代码" v-if="switchValue === 2" width="80" key="specialtyCode">
        </el-table-column>
        <el-table-column prop="specialtyName" label="专业名称" v-if="switchValue === 2" min-width="180"
                         :show-overflow-tooltip="true" key="specialtyName">
        </el-table-column>
        <el-table-column prop="scoreYearThis" width="72" key="scoreYearThisszy" v-if="volunteerMode === 3">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_year_this')">
              {{ admissionYear }}最低分
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearThis" width="72" key="accumulateYearThisszy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_this')">
              {{ admissionYear }}最低位次
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearLast" width="72" key="accumulateYearLastszy">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_last')">
              {{ admissionYear - 1 }}最低位次
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearOther" width="72" key="accumulateYearOtherszy" v-if="volunteerMode === 3">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_other')">
              {{ admissionYear - 2 }}最低位次
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYearLast" width="65" key="planYearThisszy" v-if="volunteerMode === 3">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_last')">
              {{ planYear - 1 }}计划数
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYearThis" width="65" key="planYearLastszy" v-if="volunteerMode === 3">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_this')">
              {{ planYear }}计划数
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planDiff" width="80" key="planDiffszy" v-if="volunteerMode === 3">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_diff')">
              计划增减
            </div>
          </template>
        </el-table-column>
        <el-table-column label="学费" prop="tuitionFee" width="80" v-if="showMore">
        </el-table-column>
        <el-table-column label="软科排名" prop="softScienceRanking" width="80" v-if="showMore">
        </el-table-column>
        <el-table-column label="学科评估" prop="academicAssessment" width="100" show-overflow-tooltip v-if="showMore">
          <template slot-scope="scope">
            <span>{{scope.row.academicAssessment ? scope.row.academicAssessment : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="专业硕士点" prop="masterSpecialty" width="100" show-overflow-tooltip v-if="showMore">
          <template slot-scope="scope">
            <span>{{scope.row.masterSpecialty ? scope.row.masterSpecialty : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="专业博士点" prop="doctorSpecialty" width="100" show-overflow-tooltip v-if="showMore">
          <template slot-scope="scope">
            <span>{{scope.row.doctorSpecialty ? scope.row.doctorSpecialty : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="80">
          <template slot-scope="scope">
            <input size="small" @click.stop="kong($event)" v-if="scope.row.specialtyName" v-model="scope.row.psort"
                   @focus="getOldSort(scope.row.psort)" @blur="collegeOrOptionsSpecialtySortChanged(scope.row)"
                   style="width: 26px;text-align:center;padding-left:10px;padding-right:10px"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button type="text" style="color: #f56c6c;font-size:14px;"
                       @click.stop="deleteSpecialty(scope.$index, true)" v-if="scope.row.specialtyName">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 专业志愿 -->
    <div class="table" v-if="volunteerMode === 2 && switchValue === 2">
      <el-table size="mini" ref="majorTable" style="width: 100%" :data="specialtyPlanList" :max-height="tableHeigth"
                :row-class-name="tableRowClassName" border row-key="specialtyUuid"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px', 'padding': '0px' }"
                @row-click="handleRowSelectionChangeMajor" @selection-change="handleSelectionMajorChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="aspirationName" label="志愿" width="60">
          <template slot-scope="scope">
            {{ scope.row.psort }}
          </template>
        </el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" width="80" key="collegeCodezy1"></el-table-column>
        <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true" min-width="120"
                         key="collegeNamezy1"></el-table-column>
        <el-table-column  prop="collegeTag" label="院校标签" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeTag ? scope.row.collegeTag : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column  prop="collegeCharacter" label="院校性质" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.collegeCharacter ? scope.row.collegeCharacter : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="scoreYearThis2" key="scoreCollegezy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_college')">
              {{ admissionYear }}最低分
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="specialtyCode" label="专业代码" v-if="switchValue === 2" width="80"
                         key="specialtyCode1">
        </el-table-column>
        <el-table-column prop="specialtyName" label="专业名称" v-if="switchValue === 2" min-width="180"
                         :show-overflow-tooltip="true" key="specialtyName1">
        </el-table-column>
        <el-table-column label="选考科目要求" min-width="150" show-overflow-tooltip v-if="volunteerMode !== 1"
                         key="requiredType1">
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="scoreYearThis" key="scoreYearThiszy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'score_year_this')">
              {{ admissionYear }}最低分
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearThis" width="72" key="accumulateYearThiszy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_this')">
              {{ admissionYear }}最低位次
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearLast" width="72" key="accumulateYearLastzy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_last')">
              {{ admissionYear - 1 }}最低位次
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="accumulateYearOther" width="72" key="accumulateYearOtherzy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'accumulate_year_other')">
              {{ admissionYear - 2 }}最低位次
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYearLast" width="65" key="planYearThiszy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_last')">
              {{ planYear - 1 }}计划数
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planYearThis" width="65" key="planYearLastzy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_year_this')">
              {{ planYear }}计划数
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planDiff" width="80" key="planDiffzy1">
          <template slot="header">
            <div @click="updateDraftPlanSort(true, 'plan_diff')">
              计划增减
            </div>
          </template>
        </el-table-column>
        <el-table-column label="学费" prop="tuitionFee" width="80" v-if="showMore">
        </el-table-column>
        <el-table-column label="院校城市" width="120" v-if="showMore">
          <template slot-scope="scope">
            <span v-if="scope.row.collegeProvince">{{scope.row.collegeProvince}}</span>
            <span v-if="scope.row.collegeCity">{{scope.row.collegeCity}}</span>
          </template>
        </el-table-column>
        <el-table-column label="保研率" prop="postgraduateAdmissionRate" width="80" v-if="showMore">
        </el-table-column>
        <el-table-column label="硕士专业数" prop="masterSpecialtyNum" width="70" v-if="showMore">
        </el-table-column>
        <el-table-column label="博士专业数" prop="doctorSpecialtyNum" width="70" v-if="showMore">
        </el-table-column>
        <el-table-column label="软科排名" prop="softScienceRanking" width="80" v-if="showMore">
        </el-table-column>
        <el-table-column label="学科评估" prop="academicAssessment" width="100" show-overflow-tooltip v-if="showMore">
          <template slot-scope="scope">
            <span>{{scope.row.academicAssessment ? scope.row.academicAssessment : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="专业硕士点" prop="masterSpecialty" width="100" show-overflow-tooltip v-if="showMore">
          <template slot-scope="scope">
            <span>{{scope.row.masterSpecialty ? scope.row.masterSpecialty : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="专业博士点" prop="doctorSpecialty" width="100" show-overflow-tooltip v-if="showMore">
          <template slot-scope="scope">
            <span>{{scope.row.doctorSpecialty ? scope.row.doctorSpecialty : '/'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="80">
          <template slot-scope="scope">
            <input size="small" v-model="scope.row.psort" @click.stop="kong($event)"
                   @blur="specialtySortChanged(scope.row, scope.$index)"
                   style="width: 26px;text-align:center;padding-left:10px;padding-right:10px"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button type="text" style="color: #f56c6c;font-size:14px;"
                       @click.stop="deleteSpecialty(scope.$index, false)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top:10px" v-if="switchValue === 1 && volunteerMode !== 3">已经选择{{
        collegePlanList ? collegePlanList.length : 0
      }}所学校，{{ specialtyPlanList.length }}个专业
    </div>
    <div style="margin-top:10px" v-if="switchValue === 1  && volunteerMode === 3">已经选择{{
        collegePlanList ? collegePlanList.length : 0
      }}所学校，{{ optionsPlanList.length }}个专业组
    </div>
    <div style="margin-top:10px" v-if="switchValue === 3">已经选择{{
        optionsPlanList.length
      }}个专业组，{{ specialtyPlanList.length }}个专业
    </div>
    <div style="margin-top:10px" v-if="switchValue === 2">已经选择{{ specialtyPlanList.length }}个专业</div>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import lpyMixin from "@/mixin/lpyMixin";
import {updateDraftPlanSort} from "@/api/serviceManagement.js";

export default {
  mixins: [lpyMixin],
  components: {
    Sortable,
  },
  props: {
    idOne: {
      type: String,
      default: "",
    },
    activeName: {
      type: String,
      default: "",
    },
    voPa: {
      type: Number,
      default: 0,
    },
    id: {
      type: String,
      default: "",
    },
    planYear: {
      type: Number,
      default: new Date().getFullYear(),
    },
    admissionYear: {
      type: Number,
      default: new Date().getFullYear() - 1,
    },
  },
  data() {
    return {
      volunteerMode: 0,
      switchValue: 2,
      tableHeightSubtract: 200,
      collegePlanList: [], //院校志愿
      optionsPlanList: [], //专业组志愿
      specialtyPlanList: [], //专业志愿
      spanArr: [],
      pos: 0,
      oldSOrt: 0,
      fatherSort: 0,
      order: null,
      row: {},
      draftId: "",
      chooseSchoolList: [],
      chooseOptionsList: [],
      chooseSpecialtyList: [],
      chooseSpecialtyList1: [],
      //展示更多信息，默认不展示
      showMore: false
    };
  },
  watch: {
    voPa: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.volunteerMode = newValue;
        this.switchChange();
      },
      deep: true,
    },
    id: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.draftId = newValue;
      },
      deep: true,
    },
  },
  mounted() {
  },
  created() {
  },
  methods: {
    matchRequiredType(requiredType) {
      switch (requiredType) {
        case 0:
          return "不提科目要求";
        case 1:
          return "任选一门报考：";
        case 2:
          return "均报考：";
      }
    },
    /**
     * 修改草稿方案排序
     * @param asc
     * @param column
     */
    updateDraftPlanSort(asc, column) {
      this.$confirm("排序之前请确认方案是否已经保存，未保存请先保存", "温馨提示", {
        confirmButtonText: "我已保存",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        updateDraftPlanSort({
          admitBatch: this.activeName,
          dataType: this.switchValue,
          voPa: this.volunteerMode,
          draftId: this.draftId,
          orderItem: {asc: asc, column: column},
        }).then((res) => {
          if (res.code === 1) {
            this.$emit("getDraftPlanDetail", this.draftId);
          }
        });
      }).catch(() => {

      })
    },

    /**
     * 专业组志愿添加专业
     * @param data
     */
    addSpecialtyByOptionsClick(data) {
      this.$emit("addSpecialtyByOptionsClick", data);
    },
    /**
     * 批量删除
     */
    batchDelete() {
      if (this.switchValue === 1) {
        if (this.chooseSchoolList.length < 1) {
          this.$message({
            message: "请先选择删除院校",
            type: "warning",
          });
          return;
        }
      }
      if (this.switchValue === 2) {
        if (this.chooseSpecialtyList.length < 1) {
          this.$message({
            message: "请先选择删除专业",
            type: "warning",
          });
          return;
        }
      }
      if (this.switchValue === 3) {
        if (this.chooseOptionsList.length < 1) {
          this.$message({
            message: "请先选择删除专业组",
            type: "warning",
          });
          return;
        }
      }
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.switchValue === 1) {
          console.log("批量删除院校");
          // 院校
          this.collegePlanList = this.collegePlanList.filter((item) => {
            return this.chooseSchoolList.indexOf(item.collegeName) === -1;
          });

          let afterDeleteOptionsList = [];
          let afterDeleteSpecialtyList = [];

          this.collegePlanList.forEach((college, index) => {
            //重新对院校进行排序
            college.sort = index + 1;
            if (this.volunteerMode === 1) {
              if (college.specialtyList && college.specialtyList.length > 0) {
                college.specialtyList.forEach((item) => {
                  item.sort = college.sort;
                });
              }
            } else if (this.volunteerMode === 2) {
              if (college.specialtyList && college.specialtyList.length > 0) {
                afterDeleteSpecialtyList = [...afterDeleteSpecialtyList, ...college.specialtyList];
              }
            } else if (this.volunteerMode === 3) {
              if (college.optionsList && college.optionsList.length > 0) {
                afterDeleteOptionsList = [...afterDeleteOptionsList, ...college.optionsList];

                college.optionsList.forEach(options => {
                  if (options.specialtyList && options.specialtyList.length > 0) {
                    afterDeleteSpecialtyList = [...afterDeleteSpecialtyList, ...options.specialtyList];
                  }
                })
              }
            }
          })

          if (this.volunteerMode === 2) {
            //将删除后的专业重新排序
            afterDeleteSpecialtyList.sort((a, b) => {
              return a.psort - b.psort;
            })

            let specialtySortMap = new Map();
            let collegeSpecialtyMap = new Map();

            afterDeleteSpecialtyList.forEach((specialty, index) => {
              specialty.psort = index + 1;
              let key = specialty.collegeName + specialty.specialtyName;
              if (!specialtySortMap.has(key)) {
                specialtySortMap.set(key, specialty.psort);
              }
              if (!collegeSpecialtyMap.has(specialty.collegeName)) {
                collegeSpecialtyMap.set(specialty.collegeName, [])
              }
              collegeSpecialtyMap.get(specialty.collegeName).push(specialty)
            })

            this.collegePlanList.forEach(college => {
              //将院校的专业列表塞给院校
              college.specialtyList = collegeSpecialtyMap.get(college.collegeName) || []

              if (college.specialtyList && college.specialtyList.length > 0) {
                college.specialtyList.forEach(specialty => {
                  let key = specialty.collegeName + specialty.specialtyName;
                  //给院校的专业重新排序
                  specialty.psort = specialtySortMap.get(key);
                })
              }
            })
          }

          if (this.volunteerMode === 3) {
            //将删除之后的专业组按照顺序重新排序
            afterDeleteOptionsList.sort((a, b) => {
              return a.sort - b.sort;
            })
            let optionsSortMap = new Map();
            let collegeOptionsMap = new Map();
            afterDeleteOptionsList.forEach((options, index) => {
              options.sort = index + 1;
              let optionsKey = options.collegeName + options.specialtyOptions;
              if (!optionsSortMap.has(optionsKey)) {
                optionsSortMap.set(optionsKey, options.sort);
              }
              if (!collegeOptionsMap.has(options.collegeName)) {
                collegeOptionsMap.set(options.collegeName, [])
              }
              collegeOptionsMap.get(options.collegeName).push(options)
            })

            let specialtySortMap = new Map();
            let optionsSpecialtyMap = new Map();
            afterDeleteSpecialtyList.forEach((specialty, index) => {
              specialty.psot = index + 1;
              let specialtyKey = specialty.collegeName + specialty.specialtyName;
              if (!specialtySortMap.has(specialtyKey)) {
                specialtySortMap.set(specialtyKey, specialty.psort);
              }
              let optionsKey = specialty.collegeName + specialty.specialtyOptions;
              if (!optionsSpecialtyMap.has(optionsKey)) {
                optionsSpecialtyMap.set(optionsKey, [])
              }
              optionsSpecialtyMap.get(optionsKey).push(specialty)
            })

            this.specialtyPlanList = []
            this.collegePlanList.forEach(item => {
              item.optionsList = collegeOptionsMap.get(item.collegeName) || []
              if (item.optionsList && item.optionsList.length > 0) {
                item.optionsList.forEach(options => {
                  let optionsKey = options.collegeName + options.specialtyOptions;
                  options.sort = optionsSortMap.get(optionsKey);

                  options.specialtyList = optionsSpecialtyMap.get(optionsKey) || []
                  if (options.specialtyList && options.specialtyList.length > 0) {
                    options.specialtyList.forEach(specialty => {
                      let specialtyKey = specialty.collegeName + specialty.specialtyName;
                      specialty.sort = options.sort;
                      specialty.psort = specialtySortMap.get(specialtyKey)
                    })
                    this.specialtyPlanList = [...this.specialtyPlanList, ...options.specialtyList];
                  }
                })
              }
            })
          }
          this.$emit("collegeChanged", this.collegePlanList);
        }
        if (this.switchValue === 2) {
          console.log("批量删除专业");
          // 专业模式
          if (this.volunteerMode === 2) {
            this.specialtyPlanList.forEach((spe, n) => {
              this.chooseSpecialtyList.forEach((chooseSpe) => {
                if (chooseSpe.specialtyName) {
                  if (
                      spe.collegeName === chooseSpe.collegeName &&
                      spe.specialtyName === chooseSpe.specialtyName
                  ) {
                    this.specialtyPlanList.splice(n, 1);
                  }
                } else {
                  this.collegePlanList.forEach((sch, ind) => {
                    if (sch.collegeName === chooseSpe.collegeName) {
                      this.collegePlanList.splice(ind, 1);
                      for (let i = ind; i < this.collegePlanList.length; i++) {
                        this.collegePlanList[i].sort = this.collegePlanList[i].sort - 1;
                      }
                    }
                  });
                }
              });
            });

            this.specialtyPlanList = this.specialtyPlanList.filter((item) => {
              return (
                  this.chooseSpecialtyList1.indexOf(item.specialtyUuid) === -1
              );
            });
            for (let i = 0; i < this.specialtyPlanList.length; i++) {
              this.specialtyPlanList[i].psort = i + 1;
            }
            this.collegePlanList.forEach((college) => {
              college.specialtyList = [];
              if (this.specialtyPlanList && this.specialtyPlanList.length > 0) {
                this.specialtyPlanList.forEach(specialty => {
                  if (
                      specialty.collegeName === college.collegeName &&
                      specialty.specialtyOptions === college.specialtyOptions
                  ) {
                    college.specialtyList.push(specialty);
                  }
                });
              }
            });
            this.$emit("collegeChanged", this.collegePlanList);
          } else {
            // chooseSpecialtyList 选择专业数组
            // 专业组模式
            if (this.volunteerMode === 3) {
              console.log("专业 - 专业组模式");
              this.collegePlanList.forEach((school, index) => {
                this.chooseSpecialtyList.forEach((row) => {
                  if (school.collegeName === row.collegeName) {
                    if (school.optionsList && school.optionsList.length > 0) {
                      school.optionsList.forEach((options, i) => {
                        if (
                            options.collegeName === row.collegeName &&
                            options.specialtyOptions === row.specialtyOptions
                        ) {
                          this.collegePlanList[index].optionsList.splice(i, 1);
                        }
                      });
                    }
                  }
                });
              });
              this.specialtyPlanList = [];
              this.optionsPlanList = [];
              this.collegePlanList.forEach((college) => {
                if (college.optionsList && college.optionsList.length > 0) {
                  this.optionsPlanList = [
                    ...this.optionsPlanList,
                    ...college.optionsList,
                  ];
                  college.optionsList.forEach((option) => {
                    if (option.specialtyList) {
                      this.specialtyPlanList = [
                        ...this.specialtyPlanList,
                        ...option.specialtyList,
                      ];
                    }
                  });
                }
              });
              this.optionsPlanList.sort(function (a, b) {
                return a.sort - b.sort;
              });
              for (let i = 0; i < this.optionsPlanList.length; i++) {
                this.optionsPlanList[i].sort = i + 1;
              }
              this.$emit("specialtyOptionsChanged", this.optionsPlanList);
            }
            // 院校模式
            if (this.volunteerMode === 1) {
              console.log("专业院校批量删除");
              this.collegePlanList.forEach((school, index) => {
                this.chooseSpecialtyList.forEach((row) => {
                  if (
                      school.collegeName === row.collegeName &&
                      school.collegeCode === row.collegeCode
                  ) {
                    this.collegePlanList.splice(index, 1);
                  }
                });
              });
              this.specialtyPlanList = [];
              this.collegePlanList.forEach((college, i) => {
                college.sort = i + 1;
                if (college.specialtyList && college.specialtyList.length > 0) {
                  college.specialtyList.forEach((item) => {
                    item.sort = college.sort;
                  });
                  this.specialtyPlanList = [
                    ...this.specialtyPlanList,
                    ...college.specialtyList,
                  ];
                }
              });
              this.$emit("collegeChanged", this.collegePlanList);
              this.switchChange();
            }
          }
        }
        if (this.switchValue === 3) {
          console.log("批量删除专业组");
          this.optionsPlanList = this.optionsPlanList.filter((item) => {
            return this.chooseOptionsList.indexOf(item.collegeName + item.specialtyOptions) === -1;
          });

          this.specialtyPlanList = [];

          let optionsSortMap = new Map();
          let collegeOptionsMap = new Map();
          this.optionsPlanList.forEach((options, index) => {
            options.sort = index + 1;
            let optionsKey = options.collegeName + options.specialtyOptions;
            if (!optionsSortMap.has(optionsKey)) {
              optionsSortMap.set(optionsKey, options.sort);
            }
            if (!collegeOptionsMap.has(options.collegeName)) {
              collegeOptionsMap.set(options.collegeName, [])
            }
            collegeOptionsMap.get(options.collegeName).push(options)

            if (options.specialtyList && options.specialtyList.length > 0) {
              this.specialtyPlanList = [...this.specialtyPlanList, ...options.specialtyList,];
            }
          })

          let optionsSpecialtyMap = new Map();
          this.specialtyPlanList.forEach(specialty => {
            let optionsKey = specialty.collegeName + specialty.specialtyOptions;
            if (!optionsSpecialtyMap.has(optionsKey)) {
              optionsSpecialtyMap.set(optionsKey, [])
            }
            optionsSpecialtyMap.get(optionsKey).push(specialty)
          })

          this.specialtyPlanList = []
          this.collegePlanList.forEach(item => {
            item.optionsList = collegeOptionsMap.get(item.collegeName) || []
            if (item.optionsList && item.optionsList.length > 0) {
              item.optionsList.forEach(options => {
                let optionsKey = options.collegeName + options.specialtyOptions;
                options.sort = optionsSortMap.get(optionsKey);

                options.specialtyList = optionsSpecialtyMap.get(optionsKey) || []
                if (options.specialtyList && options.specialtyList.length > 0) {
                  options.specialtyList.forEach(specialty => {
                    specialty.sort = options.sort;
                  })
                  this.specialtyPlanList = [...this.specialtyPlanList, ...options.specialtyList];
                }
              })
            }
          })

          this.$emit("collegeChanged", this.collegePlanList);
        }
      });
    },
    kong(e) {
      e.currentTarget.select();
    },
    //院校志愿选择与否
    handleCollegeSelectionChanged(val) {
      this.chooseSchoolList = [];
      val.forEach((item) => {
        this.chooseSchoolList.push(item.collegeName);
      });
    },
    handleCollegeRowSelectionChanged(row, col, event) {
      row.flag = !row.flag;
      let volunteerMode = null;
      let isHaveItem = this.chooseSchoolList.find(
          (item) => row.collegeName === item
      );
      if (isHaveItem) {
        volunteerMode = false;
        this.chooseSchoolList = this.chooseSchoolList.filter(
            (item) => isHaveItem !== item
        );
      } else {
        volunteerMode = true;
        this.chooseSchoolList.push(row.collegeName);
      }
      this.$refs.schoolTable.toggleRowSelection(row, volunteerMode);
    },
    //添加专业组弹框专业组严重
    handleSelectionOptionsChange(val) {
      this.chooseOptionsList = [];
      val.forEach((item) => {
        this.chooseOptionsList.push(item.collegeName + item.specialtyOptions);
      });
    },
    handleRowSelectionChangeOptions(row, col, event) {
      row.flag = !row.flag;
      let volunteerMode = null;
      let isHaveItem = this.chooseOptionsList.find(
          (item) => row.collegeName + row.specialtyOptions === item
      );
      if (isHaveItem) {
        volunteerMode = false;
        this.chooseOptionsList = this.chooseOptionsList.filter(
            (item) => isHaveItem !== item
        );
      } else {
        volunteerMode = true;
        this.chooseOptionsList.push(row.collegeName + row.specialtyOptions);
      }
      this.$refs.optionsTable.toggleRowSelection(row, volunteerMode);
    },
    handleSelectionMajorChange(val) {
      this.chooseSpecialtyList = val;
      this.chooseSpecialtyList1 = [];
      val.forEach((item) => {
        this.chooseSpecialtyList1.push(item.specialtyUuid);
      });
    },
    handleRowSelectionChangeMajor(row, col, event) {
      row.flag = !row.flag;
      let volunteerMode = null;
      let isHaveItem = this.chooseSpecialtyList1.find(
          (item) => row.specialtyUuid === item
      )
      if (isHaveItem) {
        volunteerMode = false;
        this.chooseSpecialtyList1 = this.chooseSpecialtyList1.filter(
            (item) => isHaveItem !== item
        );
      } else {
        volunteerMode = true;
        this.chooseSpecialtyList1.push(row.specialtyUuid);
      }
      this.$refs.majorTable.toggleRowSelection(row, volunteerMode);
    },
    //打印
    exportTemplate(type, includeMoreInfo) {
      this.$emit("exportTemplate", {type: type, includeMoreInfo: includeMoreInfo});
    },
    //专业组志愿编辑专业
    editSpecialtyByOptionsClick(data) {
      this.$emit("editSpecialtyByOptionsClick", data);
    },
    /**
     * 删除专业组
     * @param index 删除专业组下标
     */
    deleteSpecialtyOptions(index) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.optionsPlanList.splice(index, 1);
        for (let i = index; i < this.optionsPlanList.length; i++) {
          this.optionsPlanList[i].sort = this.optionsPlanList[i].sort - 1;
        }
        this.specialtyPlanList = [];

        let collegeOptionsMap = new Map();

        this.optionsPlanList.forEach(options => {
          if (options.specialtyList && options.specialtyList.length > 0) {
            this.specialtyPlanList = [...this.specialtyPlanList, ...options.specialtyList,];
          }
          if (!collegeOptionsMap.has(options.collegeName)) {
            collegeOptionsMap.set(options.collegeName, [])
          }
          collegeOptionsMap.get(options.collegeName).push(options)
        })

        let optionsSpecialtyMap = new Map();
        this.specialtyPlanList.forEach(specialty => {
          let optionsKey = specialty.collegeName + specialty.specialtyOptions;
          if (!optionsSpecialtyMap.has(optionsKey)) {
            optionsSpecialtyMap.set(optionsKey, [])
          }
          optionsSpecialtyMap.get(optionsKey).push(specialty)
        })

        this.specialtyPlanList = []
        this.collegePlanList.forEach(item => {
          item.optionsList = collegeOptionsMap.get(item.collegeName) || []
          if (item.optionsList && item.optionsList.length > 0) {
            item.optionsList.forEach(options => {
              let optionsKey = options.collegeName + options.specialtyOptions;

              options.specialtyList = optionsSpecialtyMap.get(optionsKey) || []
              if (options.specialtyList && options.specialtyList.length > 0) {
                options.specialtyList.forEach(specialty => {
                  specialty.sort = options.sort;
                })
                this.specialtyPlanList = [...this.specialtyPlanList, ...options.specialtyList];
              }
            })
          }
        })

        this.$emit("collegeChanged", this.collegePlanList);
      });
    },
    addSpecialtyClick() {
      this.$emit("addSpecialtyClick");
    },
    addSpecialtyOptionsClick(type, data) {
      this.$emit("addSpecialtyOptionsClick", {type: type, data: data});
    },
    addCollegeClick() {
      this.$emit("addCollegeClick");
    },
    // 拖动行
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      if (tbody) {
        Sortable.create(tbody, {
          animation: 100,
          onEnd({oldIndex, newIndex}) {
            console.log(
                _this.volunteerMode,
                _this.switchValue,
                "行拖动"
            );
            console.log(`行拖动改变顺序 原下标：${oldIndex}, 新下标：${newIndex}`)
            if (_this.switchValue === 1) {
              let data = {..._this.collegePlanList[oldIndex]};
              let oldSort = data.sort;
              let newSort = newIndex + 1
              console.log(`院校通过拖动改变顺序 原序号：${oldSort}, 新序号：${newSort}`)

              if (newSort < oldSort) {
                // 大于等于newSort 小于oldSort的sort+1
                _this.collegePlanList.forEach((item) => {
                  let tempSort = parseInt(item.sort);
                  if (
                      item.collegeName !== data.collegeName &&
                      item.sort >= newSort &&
                      item.sort < oldSort
                  ) {
                    item.sort = tempSort + 1;
                  }
                  if (item.collegeName === data.collegeName) {
                    item.sort = newSort;
                  }
                });
              }

              if (newSort > oldSort) {
                //小于等于newSort 大于oldSort 的sort - 1
                _this.collegePlanList.forEach((item) => {
                  let tempSort = parseInt(item.sort);
                  if (
                      item.collegeName !== data.collegeName &&
                      item.sort > oldSort &&
                      item.sort <= newSort
                  ) {
                    item.sort = tempSort - 1;
                  }
                  if (item.collegeName === data.collegeName) {
                    item.sort = newSort;
                  }
                });
              }
              _this.collegePlanList.sort(function (a, b) {
                return a.sort - b.sort;
              });

              for (let i = 0; i < _this.collegePlanList.length; i++) {
                if (_this.volunteerMode === 1) {
                  if (_this.collegePlanList[i].specialtyList) {
                    _this.collegePlanList[i].specialtyList.forEach((specialty) => {
                      specialty.sort = i + 1;
                    });
                  }
                }
              }

              _this.$emit("collegeChanged", _this.collegePlanList);
            } else if (_this.switchValue === 2) {
              if (_this.volunteerMode === 2) {
                //原sort  index
                //现sort  data.psort
                let data = {..._this.specialtyPlanList[oldIndex]};
                let oldSort = data.psort;
                let newSort = newIndex + 1
                console.log(`专业模式通过拖动改变顺序 原序号：${oldSort}, 新序号：${newSort}`)

                if (newSort < oldSort) {
                  // 大于等于newSort 小于oldSort的sort+1
                  _this.specialtyPlanList.forEach((item) => {
                    let tempSort = parseInt(item.psort);
                    if (
                        item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
                        item.psort >= newSort &&
                        item.psort < oldSort
                    ) {
                      item.psort = tempSort + 1;
                    }
                    if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                      item.psort = newSort
                    }
                  });
                } else if (newSort > oldIndex) {
                  //小于等于newSort 大于oldSort 的sort - 1
                  _this.specialtyPlanList.forEach((item) => {
                    let tempSort = parseInt(item.psort);
                    if (
                        item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
                        item.psort > oldIndex + 1 &&
                        item.psort <= newSort
                    ) {
                      item.psort = tempSort - 1;
                    }
                    if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                      item.psort = newSort;
                    }
                  });
                }
                _this.specialtyPlanList.sort(function (a, b) {
                  return a.psort - b.psort;
                });

                _this.$emit("specialtyChanged", _this.specialtyPlanList);
              } else {
                if (
                    _this.specialtyPlanList[oldIndex].collegeName !==
                    _this.specialtyPlanList[newIndex].collegeName ||
                    _this.specialtyPlanList[oldIndex].specialtyOptions !==
                    _this.specialtyPlanList[newIndex].specialtyOptions
                ) {
                  console.log("不在同一个学校或专业组");
                  // 暴力重新渲染！
                  let volunteerMode = _this.volunteerMode;
                  _this.volunteerMode = 999;
                  console.log(_this.volunteerMode, "_this.volunteerMode");
                  // 借助nextTick和v-if重新渲染
                  _this.$nextTick(function () {
                    _this.volunteerMode = volunteerMode;
                    _this.$nextTick(function () {
                      // 重新渲染之后，重新进行Sortable绑定
                      _this.rowDrop();
                      if (_this.volunteerMode !== 2) {
                        _this.computeMerge();
                      }
                    });
                  });
                } else {
                  if (_this.volunteerMode === 1) {
                    _this.computeCollegeSpecialtySort(
                        oldIndex,
                        newIndex,
                        _this.specialtyPlanList
                    );
                  }
                  if (_this.volunteerMode === 3) {
                    _this.computeCollegeOptionsSort(
                        oldIndex,
                        newIndex,
                        _this.specialtyPlanList
                    );
                  }
                }

              }
            } else {
              //拖动专业组
              let data = {..._this.optionsPlanList[oldIndex]};
              let oldSort = data.sort;
              let newSort = newIndex + 1
              console.log(`专业组通过拖动改变顺序 原序号：${oldSort}, 新序号：${newSort}`)

              if (newSort < oldSort) {
                // 大于等于newSort 小于oldSort的sort+1
                _this.optionsPlanList.forEach((item) => {
                  let tempSort = parseInt(item.sort);
                  if (
                      item.collegeName + item.specialtyOptions !== data.collegeName + data.specialtyOptions &&
                      item.sort >= newSort &&
                      item.sort < oldSort
                  ) {
                    item.sort = tempSort + 1;
                  }
                  if (item.collegeName + item.specialtyOptions === data.collegeName + data.specialtyOptions) {
                    item.sort = newSort;
                  }
                });
              } else if (newSort > oldSort) {
                //小于等于newSort 大于oldSort 的sort - 1
                _this.optionsPlanList.forEach((item) => {
                  let tempSort = parseInt(item.sort);
                  if (
                      item.collegeName + item.specialtyOptions !== data.collegeName + data.specialtyOptions &&
                      item.sort > oldSort &&
                      item.sort <= newSort
                  ) {
                    item.sort = tempSort - 1;
                  }
                  if (item.collegeName + item.specialtyOptions === data.collegeName + data.specialtyOptions) {
                    item.sort = newSort;
                  }
                });
              }

              _this.optionsPlanList.sort(function (a, b) {
                return a.sort - b.sort;
              });
              _this.$emit("specialtyOptionsChanged", _this.optionsPlanList);
            }
          },
        });
      }
    },

    /**
     * 院校专业拖动排序
     * @param oldIndex
     * @param newIndex
     * @param oldList
     * @returns {*[]}
     */
    computeCollegeSpecialtySort(oldIndex, newIndex, oldList) {
      let data = {...oldList[oldIndex]};
      let oldSort = data.psort;
      let newSort = oldList[newIndex].psort;
      console.log(`院校专业通过拖动改变顺序 原序号：${oldSort}, 新序号：${newSort}`)
      this.collegePlanList.forEach((college) => {
        if (college.collegeName === data.collegeName) {
          if (newSort < oldSort) {
            // 大于等于newSort 小于oldSort的sort+1
            college.specialtyList.forEach((item) => {
              let tempSort = parseInt(item.psort);
              if (
                  item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
                  item.psort >= newSort &&
                  item.psort < oldSort
              ) {
                item.psort = tempSort + 1;
              }
              if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                item.psort = newSort;
              }
            });
          } else if (newSort > oldSort) {
            //小于等于newSort 大于oldSort 的sort - 1
            college.specialtyList.forEach((item) => {
              let tempSort = parseInt(item.psort);
              if (
                  item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
                  item.psort > oldSort &&
                  item.psort <= newSort
              ) {
                item.psort = tempSort - 1;
              }
              if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                item.psort = newSort;
              }
            });
          }
          college.specialtyList.sort(function (a, b) {
            return a.psort - b.psort;
          });
        }
      });
      this.$emit("collegeChanged", this.collegePlanList);
    },
    /**
     * 专业组专业拖动排序
     * @param oldIndex
     * @param newIndex
     * @param oldList
     * @returns {*[]}
     */
    computeCollegeOptionsSort(oldIndex, newIndex, oldList) {
      let data = {...oldList[oldIndex]};
      let oldSort = data.psort;
      let newSort = oldList[newIndex].psort;
      console.log(`专业组专业通过拖动改变顺序 原序号：${oldSort}, 新序号：${newSort}`)
      this.collegePlanList.forEach((college) => {
        if (college.collegeName === data.collegeName) {
          //匹配到对应院校
          if (college.optionsList && college.optionsList.length > 0) {
            college.optionsList.forEach((option) => {
              if (option.collegeName === data.collegeName &&
                  option.specialtyOptions === data.specialtyOptions
              ) {
                //匹配到对应专业组
                if (newSort < oldSort) {
                  // 大于等于newSort 小于oldSort的sort+1
                  option.specialtyList.forEach((item) => {
                    let tempSort = parseInt(item.psort);
                    if (
                        item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
                        item.psort >= newSort &&
                        item.psort < oldSort
                    ) {
                      item.psort = tempSort + 1;
                    }
                    if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                      item.psort = newSort;
                    }
                  });
                }

                if (newSort > oldSort) {
                  //小于等于newSort 大于oldSort 的sort - 1
                  option.specialtyList.forEach((item) => {
                    let tempSort = parseInt(item.psort);
                    if (
                        item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
                        item.psort > oldSort &&
                        item.psort <= newSort
                    ) {
                      item.psort = tempSort - 1;
                    }
                    if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                      item.psort = newSort;
                    }
                  });
                }
                option.specialtyList.sort(function (a, b) {
                  return a.psort - b.psort;
                });
              }
            });
          }
        }
      });
      this.$emit("collegeChanged", this.collegePlanList);
    },
    // 专业组排序
    specialtyOptionsSortChanged(row, index) {
      let oldSort = index + 1;
      let data = {...row};
      let newSort = data.sort
      console.log(`专业组通过输入框改变顺序 原序号：${oldSort}, 新序号：${newSort}`)
      if (Math.floor(newSort).toString() !== newSort) {
        this.optionsPlanList[index].sort = oldSort;
        this.$message.error("排序序号输入错误，请重新输入")
        return;
      }
      if (newSort < 1) {
        newSort = 1;
      }
      if (newSort > this.optionsPlanList.length) {
        newSort = this.optionsPlanList.length;
      }
      if (newSort < oldSort) {
        // 大于等于newSort 小于oldSort的sort+1
        this.optionsPlanList.forEach((item) => {
          let tempSort = parseInt(item.sort);
          if (
              item.collegeName + item.specialtyOptions !== data.collegeName + data.specialtyOptions &&
              item.sort >= newSort &&
              item.sort < oldSort
          ) {
            item.sort = tempSort + 1;
          }
          if (item.collegeName + item.specialtyOptions === data.collegeName + data.specialtyOptions) {
            item.sort = newSort;
          }
        });
      } else if (newSort > oldSort) {
        //小于等于newSort 大于oldSort 的sort - 1
        this.optionsPlanList.forEach((item) => {
          let tempSort = parseInt(item.sort);
          if (
              item.collegeName + item.specialtyOptions !== data.collegeName + data.specialtyOptions &&
              item.sort > oldSort &&
              item.sort <= newSort
          ) {
            item.sort = tempSort - 1;
          }
          if (item.collegeName + item.specialtyOptions === data.collegeName + data.specialtyOptions) {
            item.sort = newSort;
          }
        });
      } else {
        this.optionsPlanList.forEach((item) => {
          if (item.collegeName + item.specialtyOptions === data.collegeName + data.specialtyOptions) {
            item.sort = newSort;
          }
        });
      }
      this.optionsPlanList.sort(function (a, b) {
        return a.sort - b.sort;
      });
      this.$emit("specialtyOptionsChanged", this.optionsPlanList);
    },

    // 院校或专业组专业排序
    collegeOrOptionsSpecialtySortChanged(row) {
      this.collegePlanList.forEach((college) => {
        if (this.volunteerMode !== 3) {
          //院校
          if (college.collegeName === row.collegeName) {
            let oldSort = this.oldSOrt;
            let data = {...row};
            let newSort = data.psort;
            console.log(`院校专业通过输入改变顺序 原序号：${oldSort}, 新序号：${newSort}`)
            if (newSort < 1) {
              newSort = 1;
            }
            if (newSort > college.specialtyList.length) {
              newSort = college.specialtyList.length;
            }

            if (newSort < oldSort) {
              // 大于等于newSort 小于oldSort的sort+1
              college.specialtyList.forEach((item) => {
                let tempSort = parseInt(item.psort);
                if (
                    item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
                    item.psort >= newSort &&
                    item.psort < oldSort
                ) {
                  item.psort = tempSort + 1;
                }
                if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                  item.psort = newSort;
                }
              });
            } else if (newSort > oldSort) {
              //小于等于newSort 大于oldSort 的sort - 1
              college.specialtyList.forEach((item) => {
                let tempSort = parseInt(item.psort);
                if (
                    item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
                    item.psort > oldSort &&
                    item.psort <= newSort
                ) {
                  item.psort = tempSort - 1;
                }
                if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                  item.psort = newSort;
                }
              });
            } else {
              college.specialtyList.forEach((item) => {
                if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                  item.psort = newSort;
                }
              });
            }
            college.specialtyList.sort(function (a, b) {
              return a.psort - b.psort;
            });
          }
        } else {
          if (college.collegeName === row.collegeName) {
            if (college.optionsList && college.optionsList.length > 0) {
              college.optionsList.forEach((options) => {
                if (options.collegeName === row.collegeName &&
                    options.specialtyOptions === row.specialtyOptions) {
                  let oldSort = this.oldSOrt;
                  let data = {...row};
                  let newSort = data.psort;
                  console.log(`专业组专业通过输入改变顺序 原序号：${oldSort}, 新序号：${newSort}`)
                  if (newSort < 1) {
                    newSort = 1;
                  }
                  if (newSort > options.specialtyList.length) {
                    newSort = options.specialtyList.length;
                  }

                  if (newSort < oldSort) {
                    // 大于等于newSort 小于oldSort的sort+1
                    options.specialtyList.forEach((item) => {
                      let tempSort = parseInt(item.psort);
                      if (
                          item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
                          item.psort >= newSort &&
                          item.psort < oldSort
                      ) {
                        item.psort = tempSort + 1;
                      }
                      if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                        item.psort = newSort;
                      }
                    });
                  } else if (newSort > oldSort) {
                    //小于等于newSort 大于oldSort 的sort - 1
                    options.specialtyList.forEach((item) => {
                      let tempSort = parseInt(item.psort);
                      if (
                          item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
                          item.psort > oldSort &&
                          item.psort <= newSort
                      ) {
                        item.psort = tempSort - 1;
                      }
                      if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                        item.psort = newSort;
                      }
                    });
                  } else {
                    options.specialtyList.forEach((item) => {
                      if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
                        item.psort = newSort;
                      }
                    });
                  }
                  options.specialtyList.sort(function (a, b) {
                    return a.psort - b.psort;
                  });
                }
              });
            }
          }
        }
      });

      this.specialtyPlanList = [];
      this.collegePlanList.forEach((college) => {
        if (college.specialtyList) {
          this.specialtyPlanList = [
            ...this.specialtyPlanList,
            ...college.specialtyList,
          ];
        }
      });
      this.$emit("collegeChanged", this.collegePlanList);
    },
    // 合并列斑马线展示
    tabRowClassName({row, rowIndex}) {
      if (row.classStripe) {
        return "warning-row";
      } else if (row.type === 1) {
        return "chong";
      } else if (row.type === 2) {
        return "wen";
      } else if (row.type === 3) {
        return "bao";
      }
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 !== 0) {
        return "warning-row";
      } else if (row.type === 2) {
        return "wen";
      } else if (row.type === 3) {
        return "bao";
      } else if (row.type === 1) {
        return "chong";
      }
      // if (this.switchValue === 1 && this.volunteerMode !== 3 && row.specialtyList) {
      //   if (row.specialtyList.length < 1) {
      //     return "warning-red";
      //   }
      // }
      // if (this.switchValue === 1 && this.volunteerMode !== 3 && !row.specialtyList) {
      //   return "warning-red";
      // }
      // if (this.switchValue === 1 && this.volunteerMode === 3 && row.optionsList) {
      //   if (row.optionsList.length < 1) {
      //     return "warning-red";
      //   }
      // }
      // if (this.switchValue === 1 && this.volunteerMode === 3 && !row.optionsList) {
      //   return "warning-red";
      // }
      // if (this.switchValue === 3 && this.volunteerMode === 3 && row.specialtyList) {
      //   if (row.specialtyList.length < 1) {
      //     return "warning-red";
      //   }
      // }
      // if (this.switchValue === 3 && this.volunteerMode === 3 && !row.specialtyList) {
      //   return "warning-red";
      // }
    },
    // 获取旧排名
    getOldSort(oldSOrt) {
      this.oldSOrt = oldSOrt;
    },
    getOldFatherSort(oldSOrt) {
      this.fatherSort = oldSOrt;
    },
    /**
     * 刷新数据
     * @param collegeList 批次下院校志愿
     */
    refreshData(collegeList) {
      this.collegePlanList = [];
      if (collegeList) {
        this.collegePlanList = [...collegeList];
      }
      this.resetOptionsList();
      this.resetSpecialtyList();
      this.switchChange();
    },

    /**
     * 重置专业组方案列表
     */
    resetOptionsList() {
      if (this.volunteerMode === 3) {
        this.optionsPlanList = []
        this.collegePlanList.forEach(college => {
          if (college.optionsList && college.optionsList.length > 0) {
            this.optionsPlanList = this.optionsPlanList.concat(college.optionsList);
          }
        })
        this.optionsPlanList.sort(function (a, b) {
          return a.sort - b.sort;
        });
      }
    },

    /**
     * 重置专业方案列表
     */
    resetSpecialtyList() {
      this.specialtyPlanList = [];
      if (this.volunteerMode === 1 || this.volunteerMode === 2) {
        this.collegePlanList.forEach(college => {
          if (college.specialtyList && college.specialtyList.length > 0) {
            if (this.volunteerMode === 1) {
              college.specialtyList.forEach(specialty => {
                specialty.scoreYearThis1 = college.scoreYearThis
                specialty.accumulateYearThis2 = college.accumulateYearThis
                specialty.planYearLast1 = college.planYearLast
                specialty.planYearThis1 = college.planYearThis
                specialty.planDiff1 = college.planDiff
              })
            }
            this.specialtyPlanList = [...this.specialtyPlanList, ...college.specialtyList,];
          }
        })
      } else if (this.volunteerMode === 3) {
        this.collegePlanList.forEach(college => {
          if (college.optionsList && college.optionsList.length > 0) {
            college.optionsList.forEach(options => {
              if (!options.scoreYearThis || options.scoreYearThis === 0) {
                options.scoreYearThis = college.scoreYearThis
              }
              if (!options.accumulateYearThis || options.accumulateYearThis === 0) {
                options.accumulateYearThis = college.accumulateYearThis
              }
              if (options.specialtyList && options.specialtyList.length > 0) {
                options.specialtyList.forEach(specialty => {
                  specialty.specialtyName1 = specialty.aspirationName;
                  specialty.scoreYearThis1 = options.scoreYearThis
                  specialty.accumulateYearThis2 = options.accumulateYearThis
                  specialty.planYearLast1 = options.planYearLast
                  specialty.planYearThis1 = options.planYearThis
                  specialty.planDiff1 = options.planDiff
                })

                this.specialtyPlanList = [...this.specialtyPlanList, ...options.specialtyList]
              }
            })
          }
        })
        console.log(this.specialtyPlanList, "志愿方案")
      }
    },
    // 切换志愿视图
    switchChange(val) {
      if (val) {
        this.switchValue = val;
      }
      console.log(
          "switchValue：" +
          this.switchValue +
          "，volunteerMode：" +
          this.volunteerMode,
          "切换志愿视图"
      );
      if (this.volunteerMode === 0) {
        return;
      }
      if (this.switchValue === 2) {
        //志愿方案 专业
        this.specialtyPlanList = [];
        if (this.volunteerMode === 3) {
          if (this.collegePlanList && this.collegePlanList.length > 0) {
            this.collegePlanList.forEach((item) => {
              if (item.optionsList && item.optionsList.length > 0) {
                item.optionsList.sort((a, b) => a.sort - b.sort)
                item.optionsList.forEach((options) => {
                  if (options.specialtyList && options.specialtyList.length > 0) {
                    options.specialtyList.sort((a, b) => a.psort - b.psort)
                    this.specialtyPlanList = [
                      ...this.specialtyPlanList,
                      ...options.specialtyList,
                    ];
                  } else {
                    this.specialtyPlanList.push({
                      collegeCode: options.collegeCode,
                      collegeName: options.collegeName,
                      sort: options.sort,
                      specialtyUuid:
                          options.collegeName + options.specialtyOptions,
                      specialtyOptions: options.specialtyOptions,
                      specialtyNames: options.specialtyNames,
                      aspirationName: options.aspirationName,
                      requiredType: options.requiredType,
                      requiredDiscipline: options.requiredDiscipline,
                      scoreYearThis2: options.scoreYearThis,
                      accumulateYearThis2: options.accumulateYearThis,
                      accumulateYearLast2: options.accumulateYearLast,
                      accumulateYearOther2: options.accumulateYearOther,
                      planYearLast2: options.planYearLast,
                      planYearThis2: options.planYearThis,
                      planDiff2: options.planDiff,
                      specialtyName1: options.aspirationName,
                      scoreYearThis1: options.scoreYearThis,
                      planYearLast1: options.planYearLast,
                      planYearThis1: options.planYearThis,
                      planDiff1: options.planDiff,
                      collegeCharacter: options.collegeCharacter,
                      runType: options.runType
                    });
                  }
                });
              }
            });
          }
          //对所有专业进行排序
          this.specialtyPlanList.sort(function (a, b) {
            if (a.sort === b.sort) {
              if (a.specialtyOptions === b.specialtyOptions) {
                return a.psort - b.psort;
              } else {
                return a.specialtyOptions.localeCompare(
                    b.specialtyOptions,
                    "zh-CN"
                );
              }
            } else {
              return a.sort - b.sort;
            }
          });
          this.computeMerge();
        } else {
          if (this.collegePlanList && this.collegePlanList.length > 0) {
            this.collegePlanList.forEach((item) => {
              if (item.specialtyList && item.specialtyList.length > 0) {
                this.specialtyPlanList = [...this.specialtyPlanList, ...item.specialtyList];
              } else {
                if (this.volunteerMode !== 2) {
                  let maj = {
                    collegeCode: item.collegeCode,
                    collegeName: item.collegeName,
                    admitBatch: item.admitBatch,
                    specialtyOptions: item.specialtyOptions,
                    requiredType: item.requiredType,
                    specialtyUuid: item.collegeName + item.specialtyOptions,
                    sort: item.sort,
                    requiredDiscipline: item.requiredDiscipline,
                    scoreYearThis2: item.scoreYearThis,
                    accumulateYearThis2: item.accumulateYearThis,
                    accumulateYearLast2: item.accumulateYearLast,
                    accumulateYearOther2: item.accumulateYearOther,
                    planYearLast2: item.planYearLast,
                    planYearThis2: item.planYearThis,
                    planDiff2: item.planDiff,
                  };
                  this.specialtyPlanList.push({...maj});
                }
              }
            });
          }
          if (this.volunteerMode !== 2) {
            //非专业模式，计算合并
            this.computeMerge();
          } else {
            this.specialtyPlanList.sort(function (a, b) {
              return a.psort - b.psort;
            });
          }
        }
      }
      if (this.switchValue === 3 && this.volunteerMode === 3) {
        this.resetOptionsList();
      }
      this.$nextTick(() => {
        this.rowDrop();
      });
    },
    //计算合并位置
    computeMerge() {
      console.log("计算合并位置");
      // 先给所有的数据都加一个v.rowspan = 1
      this.specialtyPlanList.forEach((v) => {
        v.rowspan = 1;
      });
      let rowsMap = new Map();
      this.specialtyPlanList.forEach(specialty => {
        if (!specialty.specialtyOptions) {
          specialty.specialtyOptions = null;
        }
        let key = specialty.collegeName + specialty.specialtyOptions;
        if (!rowsMap.has(key)) {
          rowsMap.set(key, 1);
        } else {
          let count = parseInt(rowsMap.get(key)) + 1;
          rowsMap.set(key, count);
        }
      });

      let lastKey = "";
      let lastClassStripe = false
      this.specialtyPlanList.forEach(specialty => {
        let key = specialty.collegeName + specialty.specialtyOptions;
        if (!lastKey) {
          lastKey = key;
          lastClassStripe = false;
          //第一个
          if (rowsMap.has(lastKey)) {
            let count = rowsMap.get(lastKey);
            specialty.rowspan = parseInt(count);
          }
          specialty.classStripe = lastClassStripe
        } else {
          if (lastKey === key) {
            specialty.rowspan = 0
          } else {
            lastKey = key;
            lastClassStripe = !lastClassStripe
            if (rowsMap.has(lastKey)) {
              let count = rowsMap.get(lastKey);
              specialty.rowspan = parseInt(count);
            }
          }
          specialty.classStripe = lastClassStripe
        }
      });
    },
    //进行表格合并
    objectOneMethod({row, column, rowIndex, columnIndex}) {
      if(this.showMore) {
        if (this.volunteerMode === 1 && this.switchValue === 2) {
          if (
              columnIndex === 0 ||
              columnIndex === 1 ||
              columnIndex === 2 ||
              columnIndex === 3 ||
              columnIndex === 4 ||
              columnIndex === 5 ||
              columnIndex === 6 ||
              columnIndex === 7 ||
              columnIndex === 8 ||
              columnIndex === 9 ||
              columnIndex === 10 ||
              columnIndex === 11 ||
              columnIndex === 12 ||
              columnIndex === 13 ||
              columnIndex === 14 ||
              columnIndex === 15 ||
              columnIndex === 16
          ) {
            return {
              rowspan: row.rowspan,
              colspan: 1,
            };
          }
        }
        if (this.volunteerMode === 3 && this.switchValue === 2) {
          if (
              columnIndex === 0 ||
              columnIndex === 1 ||
              columnIndex === 2 ||
              columnIndex === 3 ||
              columnIndex === 4 ||
              columnIndex === 5 ||
              columnIndex === 6 ||
              columnIndex === 7 ||
              columnIndex === 8 ||
              columnIndex === 9 ||
              columnIndex === 10 ||
              columnIndex === 11 ||
              columnIndex === 12 ||
              columnIndex === 13 ||
              columnIndex === 14 ||
              columnIndex === 15 ||
              columnIndex === 16 ||
              columnIndex === 17 ||
              columnIndex === 18
          ) {
            return {
              rowspan: row.rowspan,
              colspan: 1,
            };
          }
        }
      } else {
        if (this.volunteerMode === 1 && this.switchValue === 2) {
          if (
              columnIndex === 0 ||
              columnIndex === 1 ||
              columnIndex === 2 ||
              columnIndex === 3 ||
              columnIndex === 4 ||
              columnIndex === 5 ||
              columnIndex === 6 ||
              columnIndex === 7 ||
              columnIndex === 8 ||
              columnIndex === 9 ||
              columnIndex === 10 ||
              columnIndex === 11 ||
              columnIndex === 12
          ) {
            return {
              rowspan: row.rowspan,
              colspan: 1,
            };
          }
        }
        if (this.volunteerMode === 3 && this.switchValue === 2) {
          if (
              columnIndex === 0 ||
              columnIndex === 1 ||
              columnIndex === 2 ||
              columnIndex === 3 ||
              columnIndex === 4 ||
              columnIndex === 5 ||
              columnIndex === 6 ||
              columnIndex === 7 ||
              columnIndex === 8 ||
              columnIndex === 9 ||
              columnIndex === 10 ||
              columnIndex === 11 ||
              columnIndex === 12 ||
              columnIndex === 13 ||
              columnIndex === 14
          ) {
            return {
              rowspan: row.rowspan,
              colspan: 1,
            };
          }
        }
      }
    },
    // 编辑
    eidit(data) {
      if (this.volunteerMode !== 3 || this.switchValue === 3) {
        this.$emit("func", data);
      } else {
        this.$emit("editOptions", data);
      }
    },
    // 院校添加专业
    collegeAddSpecialty(data) {
      this.$emit("collegeAddSpecialty", data);
    },
    // 专业模式下 专业排序改变
    specialtySortChanged(row, index) {
      //原sort  index
      //现sort  data.psort
      let oldSort = index + 1;
      let data = {...row};
      let newSort = data.psort
      console.log(`专业模式通过输入框改变顺序 原序号：${oldSort}, 新序号：${newSort}`)
      if (Math.floor(newSort).toString() !== newSort) {
        this.specialtyPlanList[index].psort = oldSort;
        this.$message.error("排序序号输入错误，请重新输入")
        return;
      }
      if (newSort < 1) {
        newSort = 1;
      }
      if (newSort > this.specialtyPlanList.length) {
        newSort = this.specialtyPlanList.length;
      }

      if (newSort < oldSort) {
        // 大于等于newSort 小于oldSort的sort+1
        this.specialtyPlanList.forEach((item) => {
          let tempSort = parseInt(item.psort);
          if (
              item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
              item.psort >= newSort &&
              item.psort < oldSort
          ) {
            item.psort = tempSort + 1;
          }
          if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
            item.psort = newSort;
          }
        });
      } else if (newSort > oldSort) {
        //小于等于newSort 大于oldSort 的sort - 1
        this.specialtyPlanList.forEach((item) => {
          let tempSort = parseInt(item.psort);
          if (
              item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
              item.psort > oldSort &&
              item.psort <= newSort
          ) {
            item.psort = tempSort - 1;
          }
          if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
            item.psort = newSort;
          }
        });
      } else {
        //相等
        this.specialtyPlanList.forEach((item) => {
          if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
            item.psort = newSort;
          }
        });
      }
      this.specialtyPlanList.sort(function (a, b) {
        return a.psort - b.psort;
      });

      this.$emit("specialtyChanged", this.specialtyPlanList);
    },
    //院校排序
    collegeSortChanged(row, index) {
      let oldSort = index + 1;
      let data = {...row};
      let newSort = data.sort
      console.log(`院校通过输入框改变顺序 原序号：${oldSort}, 新序号：${newSort}`)
      if (Math.floor(newSort).toString() !== newSort) {
        this.collegePlanList[index].sort = oldSort;
        this.$message.error("排序序号输入错误，请重新输入")
        return;
      }
      if (newSort < 1) {
        newSort = 1;
      }
      if (newSort > this.collegePlanList.length) {
        newSort = this.collegePlanList.length;
      }
      if (newSort < oldSort) {
        // 大于等于newSort 小于oldSort的sort+1
        this.collegePlanList.forEach((item) => {
          let tempSort = parseInt(item.sort);
          if (
              item.collegeName !== data.collegeName &&
              item.sort >= newSort &&
              item.sort < oldSort
          ) {
            item.sort = tempSort + 1;
          }
          if (item.collegeName === data.collegeName) {
            item.sort = newSort;
          }
        });
      } else if (newSort > oldSort) {
        //小于等于newSort 大于oldSort 的sort - 1
        this.collegePlanList.forEach((item) => {
          let tempSort = parseInt(item.sort);
          if (
              item.collegeName !== data.collegeName &&
              item.sort > oldSort &&
              item.sort <= newSort
          ) {
            item.sort = tempSort - 1;
          }
          if (item.collegeName === data.collegeName) {
            item.sort = newSort;
          }
        });
      } else {
        this.collegePlanList.forEach((item) => {
          if (item.collegeName === data.collegeName) {
            item.sort = newSort;
          }
        });
      }

      this.collegePlanList.sort(function (a, b) {
        return a.sort - b.sort;
      });

      for (let i = 0; i < this.collegePlanList.length; i++) {
        if (this.volunteerMode === 1) {
          if (this.collegePlanList[i].specialtyList) {
            this.collegePlanList[i].specialtyList.forEach((specialty) => {
              specialty.sort = i + 1;
            });
          }
        }
      }

      this.$emit("collegeChanged", this.collegePlanList);
    },
    /**
     * 删除院校志愿
     * @param index 删除的下标
     */
    deleteCollegePlan(index) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.collegePlanList.splice(index, 1);

        for (let i = index; i < this.collegePlanList.length; i++) {
          this.collegePlanList[i].sort = this.collegePlanList[i].sort - 1;
          if (this.volunteerMode === 1) {
            this.collegePlanList[i].specialtyList.forEach((specialty) => {
              specialty.sort = this.collegePlanList[i].sort;
            });
          }
        }

        if (this.volunteerMode === 1) {
          //院校模式删除院校无需处理

          // this.specialtyPlanList = [];
          //
          // this.collegePlanList.forEach(item => {
          //   if (item.specialtyList && item.specialtyList.length > 0) {
          //     this.specialtyPlanList = [...this.specialtyPlanList, ...item.specialtyList];
          //   }
          // })
        } else if (this.volunteerMode === 2) {
          //专业模式 删除院校后，需要处理专业顺序
          this.specialtyPlanList = [];

          this.collegePlanList.forEach(item => {
            if (item.specialtyList && item.specialtyList.length > 0) {
              this.specialtyPlanList = [...this.specialtyPlanList, ...item.specialtyList];
            }
          })
          this.specialtyPlanList.sort((a, b) => {
            return a.psort - b.psort;
          })
          let collegeSpecialtyListMap = new Map();
          this.specialtyPlanList.forEach((specialty, index) => {
            specialty.psort = index + 1;
            if (!collegeSpecialtyListMap.has(specialty.collegeName)) {
              collegeSpecialtyListMap.set(specialty.collegeName, [])
            }
            collegeSpecialtyListMap.get(specialty.collegeName).push(specialty);
          })
          this.collegePlanList.forEach(college => {
            college.specialtyList = collegeSpecialtyListMap.get(college.collegeName) || [];
          })

        } else if (this.volunteerMode === 3) {
          //专业组模式 院校删除后，需要处理专业组排序，

          //删除之后所有的专业组
          let afterDeleteOptionsList = []

          this.collegePlanList.forEach(item => {
            if (item.optionsList && item.optionsList.length > 0) {
              afterDeleteOptionsList = [...afterDeleteOptionsList, ...item.optionsList]
            }
          })
          afterDeleteOptionsList.sort((a, b) => {
            return a.sort - b.sort;
          })
          //将删除之后的专业组按照顺序重新排序
          let optionsSortMap = new Map();
          afterDeleteOptionsList.forEach((options, index) => {
            options.sort = index + 1;
            let optionsKey = options.collegeName + options.specialtyOptions;
            if (!optionsSortMap.has(optionsKey)) {
              optionsSortMap.set(optionsKey, options.sort);
            }
          })

          this.specialtyPlanList = [];
          this.collegePlanList.forEach(item => {
            if (item.optionsList && item.optionsList.length > 0) {
              item.optionsList.forEach(options => {
                let optionsKey = options.collegeName + options.specialtyOptions;
                options.sort = optionsSortMap.get(optionsKey);
                if (options.specialtyList && options.specialtyList.length > 0) {
                  options.specialtyList.forEach(specialty => {
                    specialty.sort = options.sort;
                  })
                  this.specialtyPlanList = [
                    ...this.specialtyPlanList,
                    ...options.specialtyList,
                  ];
                }
              })
            }
          })
        }
        this.$emit("collegeChanged", this.collegePlanList);
      });
    },
    //删除专业志愿
    deleteSpecialty(index, isCollegeOrOptions) {
      console.log(
          "isCollegeOrOptions：" +
          isCollegeOrOptions +
          ", volunteerMode：" +
          this.volunteerMode,
          "删除专业"
      );
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (isCollegeOrOptions) {
          if (this.volunteerMode !== 3) {
            let row = this.specialtyPlanList[index];
            this.collegePlanList.forEach(college => {
              if (college.collegeName === row.collegeName) {
                if (row.specialtyName) {
                  college.specialtyList.splice(row.psort - 1, 1);
                  college.specialtyList.sort(function (a, b) {
                    return a.psort - b.psort;
                  });
                  college.specialtyList.forEach((specialty, index) => {
                    specialty.psort = index + 1;
                  });
                } else {
                  this.$alert("该专业志愿为填充空专业，如需删除该院校专业，请切换至【院校志愿】删除对应院校即可",
                      "温馨提示")
                }
              }
            });
            this.specialtyPlanList = [];
            this.collegePlanList.forEach((college) => {
              if (college.specialtyList) {
                this.specialtyPlanList = [
                  ...this.specialtyPlanList,
                  ...college.specialtyList,
                ];
              }
            });
            this.$emit("collegeChanged", this.collegePlanList);
          } else {
            let row = this.specialtyPlanList[index];
            this.collegePlanList.forEach((school) => {
              if (school.collegeName === row.collegeName) {
                if (school.optionsList && school.optionsList.length > 0) {
                  school.optionsList.forEach((options) => {
                    if (
                        options.collegeName === row.collegeName &&
                        options.specialtyOptions === row.specialtyOptions
                    ) {
                      if (row.specialtyName) {
                        options.specialtyList.splice(row.psort - 1, 1);
                        options.specialtyList.sort(function (a, b) {
                          return a.psort - b.psort;
                        });
                        options.specialtyList.forEach((specialty, index) => {
                          specialty.psort = index + 1;
                        });
                        this.$emit("collegeChanged", this.collegePlanList);
                      } else {
                        this.$alert("该专业志愿为填充空专业，如需删除该专业组专业，请切换至【专业组志愿】删除对应专业组即可",
                            "温馨提示")
                      }
                    }
                  });
                }
              }
            });
          }
        } else {
          if (this.specialtyPlanList[index].specialtyName) {
            this.specialtyPlanList.splice(index, 1);
            for (let i = index; i < this.specialtyPlanList.length; i++) {
              this.specialtyPlanList[i].psort = this.specialtyPlanList[i].psort - 1;
            }
            this.$emit("specialtyChanged", this.specialtyPlanList);
          } else {
            this.$alert("该专业志愿为填充空专业，如需删除该院校专业，请切换至【院校志愿】删除对应院校即可",
                "温馨提示")
          }
        }
      });
    },

    /**
     * 匹配院校类型
     * @param data
     * @returns {string}
     */
    matchRunType(data) {
      switch (data) {
        case 0:
          return "全部";
        case 1:
          return "公办";
        case 2:
          return "民办";
        case 3:
          return "其他";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.all {
  .switch {
    float: right;
    margin-bottom: 10px;
  }

  .colorRed {
    color: rgb(230, 77, 77);
  }

  .table {
    padding-top: 30px;
  }

  .footerbox {
    margin-top: 40px;
    margin-bottom: 30px;
  }
}

.el-table {
  // /deep/.chong {
  //   background-color: #ffffff !important;
  // }
  // /deep/.wen {
  //   background-color: #ebfcf5 !important;
  // }
  // /deep/.bao {
  //   background-color: #caf8e4 !important;
  // }
  /deep/ .warning-row {
    background: #ecf8f0;
    // background: #fafafa;
    // background: red;
  }

  /deep/ .warning-red {
    background: #f79e9e !important;
    // color: #ffffff!important;
  }
}
</style>
